/**
 * Utilidades para manejar el cache y resolver problemas de cache busting
 */

/**
 * Limpia el cache del navegador para resolver problemas de módulos dinámicos
 */
export const clearBrowserCache = async (): Promise<void> => {
  try {
    // Limpiar cache del navegador
    if ("caches" in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
      console.log("✅ Cache del navegador limpiado")
    }

    // Limpiar localStorage y sessionStorage
    localStorage.clear()
    sessionStorage.clear()
    console.log("✅ Storage limpiado")

    // Forzar recarga sin cache
    window.location.reload()
  } catch (error) {
    console.error("❌ Error limpiando cache:", error)
  }
}

/**
 * Verifica si hay problemas de cache y sugiere limpiar
 */
export const checkCacheIssues = (): boolean => {
  const isDev =
    window.location.hostname.includes("dev.motivy.co") ||
    window.location.hostname.includes("localhost")

  if (isDev) {
    console.warn(
      '⚠️ Si ves errores de "Failed to fetch dynamically imported module":'
    )
    console.warn("1. Abre DevTools > Application > Storage > Clear storage")
    console.warn("2. O ejecuta: clearBrowserCache() en la consola")
    console.warn("3. O fuerza recarga con Ctrl+Shift+R (Cmd+Shift+R en Mac)")
    console.warn(
      "4. Verifica que los headers de cache en Netlify estén configurados correctamente"
    )
    return true
  }

  return false
}

/**
 * Función helper para debug de cache
 */
export const debugCache = async (): Promise<void> => {
  if ("caches" in window) {
    const cacheNames = await caches.keys()
    console.log("📋 Caches disponibles:", cacheNames)

    for (const cacheName of cacheNames) {
      const cache = await caches.open(cacheName)
      const keys = await cache.keys()
      console.log(`📁 Cache "${cacheName}":`, keys.length, "entradas")

      // Mostrar URLs cacheadas
      keys.slice(0, 5).forEach((request) => {
        console.log(`  - ${request.url}`)
      })

      if (keys.length > 5) {
        console.log(`  ... y ${keys.length - 5} más`)
      }
    }
  } else {
    console.log("❌ Cache API no disponible")
  }
}

// Hacer funciones disponibles globalmente para debug
if (typeof window !== "undefined") {
  ;(window as any).clearBrowserCache = clearBrowserCache
  ;(window as any).debugCache = debugCache
  ;(window as any).checkCacheIssues = checkCacheIssues
}
